import { POLYMER_GRADES, PolymerGroup } from '@/constants/polymerGrades';

/**
 * Get readable label for a grade key using the POLYMER_GRADES config
 */
export const getReadableLabel = (key: string): string => {
  for (const polymer of Object.values(POLYMER_GRADES)) {
    const grade = polymer.find(g => g.key === key);
    if (grade) return grade.label;
  }
  return key;
};

/**
 * Generate filename for Excel export
 */
export const generateExportFilename = (polymer: PolymerGroup): string => {
  const today = new Date().toISOString().split('T')[0].replace(/-/g, '');
  return `ResinSmart-FairPrice-${polymer}-${today}.xlsx`;
};
